"use client";

import React from "react";
import GSTEInvoiceReplica from "../../../../components/GSTEInvoiceReplica";

export default function GSTEInvoicing1InvoicePage() {
  return <GSTEInvoiceReplica initialScreen="invoice" />;
}
